import { LICENSE } from '../../constants/reading/CommonConstants';

const { EXPRESS, D8 } = LICENSE;

const isStandaloneExpress = licensingInfo =>
    licensingInfo.includes(EXPRESS) && !licensingInfo.includes(D8);

export default isStandaloneExpress;
